import api from "../../../api";

export function getAllCustomerFeedback(sd, ed) {
  return api.get(`get-all-customer-feedback?startDate=${sd}&endDate=${ed}`);
}

export function getCSATFeedback(sd, ed, page) {
  return api.get(`csat-feedback?startDate=${sd}&endDate=${ed}&page=${page}`);
}

export function getTicketFeedback(sd, ed, page) {
  return api.get(`ticket-feedback?startDate=${sd}&endDate=${ed}&page=${page}`);
}

export const deliveryFeedback = (sd,ed, page)=>{
  return api.get( `delivery-feedback?startDate=${sd}&endDate=${ed}&page=${page}`);
}

export const treatmentFedback = (sd,ed, page)=>{
  return api.get( `treatment-feedback?startDate=${sd}&endDate=${ed}&page=${page}`);
}

export const femaleSurveyFeedback = (sd, ed, page) =>{
  return api.get(`female-survey?startDate=${sd}&endDate=${ed}&page=${page}`);
}

export const csatFeedbackRating = (sd,ed) =>{
  return api.get(`csat-feedback-rating?startDate=${sd}&endDate=${ed}`);
}

export const deliveryFeedbackRating = (sd,ed) =>{
  return api.get(`delivery-feedback-rating?startDate=${sd}&endDate=${ed}`)
}

export const femaleSurveyRating = (sd,ed) =>{
  return api.get(`female-survey-rating?startDate=${sd}&endDate=${ed}`);
}

export const ticketFeedbackRating = (sd, ed) =>{
  return api.get(`ticket-feedback-rating?startDate=${sd}&endDate=${ed}`);
}

export const treatmentFeedbackRating = (sd,ed) =>{
  return api.get(`treatment-feedback-rating?startDate=${sd}&endDate=${ed}`);
}

// Download-feedback

export const ticketFeedbackDownload = (sd,ed) =>{
  return api.get(`download-ticket-feedback?startDate=${sd}&endDate=${ed}`);
}

export const csatDownloadApi = (sd, ed) =>{
  return api.get(`csat-feedback-download?startDate=${sd}&endDate=${ed}`);
}

export const deliveryFeedbackDownload = (sd, ed) =>{
  return api.get(`delivery-feedback-download?startDate=${sd}&endDate=${ed}`);
}

export const femaleSurveyDownload = (sd,ed) =>{
  return api.get(`female-survey-download?startDate=${sd}&ed=${ed}`);
}

export const treatmentFeedbackDownload = (sd,ed) =>{
  return api.get(`treatment-feedback-download?startDate=${sd}&endDate=${ed}`);
}
// api fo nps
 export const npsFeedbackRating = (sd, ed) =>{
  return api.get(`feedback-rating/nps?startDate=${sd}&endDate=${ed}`)
 }

 export const npsFeedback = (sd, ed, page) =>{
  return api.get(`feedback/nps?startDate=${sd}&endDate=${ed}&page=${page}`)
 }

 export const npsFeedbackDownload = (sd, ed) =>{
  return api.get(`feedback-data-download/nps?startDate=${sd}&endDate=${ed}`);
 }